import { render, staticRenderFns } from "./RegisterLessonCustomization.vue?vue&type=template&id=cb015908&scoped=true&"
import script from "./RegisterLessonCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterLessonCustomization.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLessonCustomization.vue?vue&type=style&index=0&id=cb015908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb015908",
  null
  
)

export default component.exports